export const GET_PAYROLL_REPORT_REQUEST = "GET_PAYROLL_REPORT_REQUEST";
export const GET_COMMISSION_DETAILED_REPORT_REQUEST = "GET_COMMISSION_DETAILED_REPORT_REQUEST";
export const GET_TIPS_DETAILED_REPORT_REQUEST = "GET_TIPS_DETAILED_REPORT_REQUEST";
export const GET_HOURLY_DETAILED_REPORT_REQUEST = "GET_HOURLY_DETAILED_REPORT_REQUEST";
export const GET_SCHEDULE_DETAILED_REPORT_REQUEST = "GET_SCHEDULE_DETAILED_REPORT_REQUEST";
export const GET_INCOME_EXPENSE_REPORT_REQUEST = "GET_INCOME_EXPENSE_REPORT_REQUEST";
export const GET_MANAGER_REPORT_REQUEST = "GET_MANAGER_REPORT_REQUEST";
export const GET_PERIODS_REQUEST = "GET_PERIODS_REQUEST";
export const GET_REPORT_SUCCESS = "GET_REPORT_SUCCESS";
export const GET_REPORT_FAILURE = "GET_REPORT_FAILURE";
export const GET_REPORT_PENDING = "GET_REPORT_PENDING";
